// Core react and plugins
import React, { Component, Fragment } from 'react';
import { Navigate, Link } from 'react-router-dom';
import Password from '../../common/forms/password';
import TextInput from '../../common/forms/text-input';
import Button from '../../common/forms/button';

// Components
import Error from './../../common/forms/error';


// Component class itself
class Login extends Component {

    componentDidMount() {
        document.title = 'Sign in :: Esuubi';
    }

    render() {

        if ( this.props.rdr ) {
            return <Navigate to={ this.props.rdr } />
        }

        return (

            <Fragment>
                {/* <img src={ColourLogo} alt="CSIRT Commonwealth" className="login-logo-sml" /> */}
                <h1>Sign in</h1>

                <Error error={ this.props.error } />

                <form>
                    <TextInput label='Email' id='email' fieldName="email" handleChange={this.props.handleAuthInfo } />
                    <Password label='Password' id='password' fieldName="password" handleChange={this.props.handleAuthInfo} />
                    <Button handleClick={ (e) => this.props.loginFunc(e) } btnTxt={ this.props.btnTxt }/>

                </form>

                <p className="sml">Forgotten your password? <Link to="/u/forgotten-password">Reset it here</Link></p>
            </Fragment>

        );

    }
}

export default Login;